export default {
  latest_posts: [],
  all_posts: [],
  post: {},
  features: [],
  fighters: [],
  fighter: {},
  screenshots: [],
  videos: [],
  downloads: [],
  wallpapers: [],
  categories: [],
  homepage: {},
  user: {},
  dmcapolicy: {},
  mediaCategories: [],
  cookiePolicy: {}
};



// WEBPACK FOOTER //
// ./src/store/state.js